import api from './api';

class AuthService {
  async login(email, password) {
    const response = await api.post('/v1/auth/login', { email, password });
    const data = response.data.data || response.data;
    if (data.token) {
      localStorage.setItem('token', data.token);
      localStorage.setItem('user', JSON.stringify(data.user));
    }
    return response.data;
  }

  async register(name, email, password, password_confirmation) {
    const response = await api.post('/v1/auth/register', {
      name,
      email,
      password,
      password_confirmation,
    });
    const data = response.data.data || response.data;
    if (data.token) {
      localStorage.setItem('token', data.token);
      localStorage.setItem('user', JSON.stringify(data.user));
    }
    return response.data;
  }

  async logout() {
    try {
      await api.post('/v1/auth/logout');
    } catch (error) {
      console.error('Erro ao fazer logout:', error);
    } finally {
      localStorage.removeItem('token');
      localStorage.removeItem('user');
    }
  }

  async getProfile() {
    const response = await api.get('/v1/auth/me');
    return response.data;
  }

  async updateProfile(name) {
    const response = await api.put('/v1/auth/profile', { name });
    const data = response.data.data || response.data;
    if (data) {
      localStorage.setItem('user', JSON.stringify(data));
    }
    return response.data;
  }

  async changePassword(currentPassword, newPassword, newPasswordConfirmation) {
    const response = await api.post('/v1/auth/change-password', {
      current_password: currentPassword,
      password: newPassword,
      password_confirmation: newPasswordConfirmation,
    });
    return response.data;
  }

  isAuthenticated() {
    return !!localStorage.getItem('token');
  }

  getCurrentUser() {
    const userStr = localStorage.getItem('user');
    return userStr ? JSON.parse(userStr) : null;
  }
}

export default new AuthService();
